import { SatDikDetail } from '@/apis/types'

import { KeyValTable } from '@/components/KeyValTable'
import { MapWithBoundary } from '@/components/MapLocation/MapWithBoundary'

type Props = {
  data?: SatDikDetail
}

export function TabMap({ data }: Props) {
  return (
    <div className="flex flex-col items-start gap-2 md:flex-row">
      <div className="flex min-h-[300px] w-full flex-1 items-center justify-center rounded-lg">
        <MapWithBoundary
          position={{
            // Garis Lintang
            lat: data?.lintang || 0,
            // Garis Bujur
            lng: data?.bujur || 0,
          }}
          name={data?.nama || ''}
          minHeight={300}
        />
      </div>
      <KeyValTable
        rows={[
          {
            key: 'Lintang',
            displayName: 'Lintang',
            value: data?.lintang || '',
          },
          {
            key: 'Bujur',
            displayName: 'Bujur',
            value: data?.bujur || '',
          },
        ]}
      />
    </div>
  )
}
